import { render, staticRenderFns } from "./ReportVictimAmount.vue?vue&type=template&id=0d611c2e&scoped=true"
import script from "./ReportVictimAmount.vue?vue&type=script&lang=js"
export * from "./ReportVictimAmount.vue?vue&type=script&lang=js"
import style0 from "./ReportVictimAmount.vue?vue&type=style&index=0&id=0d611c2e&prod&scoped=true&lang=css"
import style1 from "./ReportVictimAmount.vue?vue&type=style&index=1&id=0d611c2e&prod&lang=css"
import style2 from "./ReportVictimAmount.vue?vue&type=style&index=2&id=0d611c2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d611c2e",
  null
  
)

export default component.exports